/**
 * Workspace roles as the reader sees them (spec §8.23). The API speaks `owner`/`editor`/`viewer`;
 * the interface speaks the reader's language. Literal keys rather than a template, so the catalogue
 * test can see that each one is used.
 */
const ROLE_KEYS: Record<string, string> = {
  owner: "role.owner",
  editor: "role.editor",
  viewer: "role.viewer",
};

/** The catalogue key for a role; an unknown role falls through to its own name. */
export const roleKey = (role: string): string => ROLE_KEYS[role] ?? role;
